// extracted by mini-css-extract-plugin
export default {"genBox":"Generator_genBox__UudQG","checkBoxContainer":"Generator_checkBoxContainer__G0tOi"};